export default __webpack_public_path__ + "static/media/icon_20.ef240478.png";